<template>
    <div class="address">
        <Head
            :headInfo='headInfo'
            @onClickLeft='onBack'
            @onClickRight='onSubmit'
        />
        <div class="addressForm" >
            <div class="item borderBot">
                <span class="addressBook">
                    <input type="text" v-model="from.name" maxlength="10" placeholder="提货人">
                    <div class="addrImg" @click="addressBook"><img src="../../../assets/img/b2b/tab5-1.png" alt=""></div>
                </span>
            </div>
            <div class="item">
                <span><input type="text" v-model="from.phone" maxlength="11" placeholder="手机号码"></span>
            </div>
        </div>
        <div class="addressList">
            <div class="item" v-for="item in depotAddressList" :key="item.id" @click="onAddress(item)">
                <div class="item-left">
                    <input class="doRadio" type="radio" name="depot" :checked="item.id === from.id">
                    <label></label>
                </div>
                <div class="item-center">
                    <div class="content" v-text="item.province + ' ' + item.city + ' ' + item.area + ' ' + item.address"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { depotAddress } from '../../b2b/api/address'
import { Toast } from 'vant'
import Head from '../../common/head'
import { versions } from '../../common/version'
import { mapMutations } from 'vuex'
export default {
    name: 'selectDeliveryAddress',
    components: {
        Head
    },
    props: {
        pickAddress: {
            type: null,
            default: null
        },
        pickCode: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            headInfo: {
                title: '选择提货地址',
                rightText: '确认'
            },
            depotAddressList: [],
            from: {
                id: '',
                name: '',
                phone: '',
                province: '',
                city: '',
                area: '',
                address: '',
                contactName: '',
                contactPhone: ''
            }
        }
    },
    methods: {
        ...mapMutations({
            setAddressInfo: 'GET_ADDRESSLIST_INFO'
        }),
        onBack () {
            this.$emit('getPickBack')
        },
        onSubmit () {
            let phone = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
            if (!this.from.name) {
                Toast('请输入提货人姓名')
                return false
            }
            if (!this.from.name.length > 10) {
                Toast('姓名最多可输入10个字')
                return false
            }
            if (!this.from.phone) {
                Toast('请输入提货人手机号码')
                return false
            }
            if (!phone.test(this.from.phone)) {
                Toast('请输入11位手机号码')
                return false
            }
            if (!this.from.id) {
                Toast('请选择提货地址')
                return false
            }
            this.$emit('getPickBack', this.from)
        },
        onAddress (obj) {
            this.from = {
                ...this.from,
                id: obj.id,
                province: obj.province,
                city: obj.city,
                area: obj.area,
                address: obj.address,
                contactName: obj.contactName,
                contactPhone: obj.contactPhone
            }
        },
        addressBook () {
            if (versions().ios || versions().iPhone || versions().iPad) {
                window.webkit.messageHandlers.dfxB2b.postMessage({
                    'method': 'getTelePhone'
                })
            } else {
                window.kfxt.getTelePhone()
            }
        },
        setTelePhone (name, phone) {
            this.from.name = name
            this.from.phone = phone
        },
        async getDepotAddress () {
            const { data } = await depotAddress({
                merchantCode: this.pickCode
            })
            if (!data.length) {
                this.titleRight = ''
            }
            this.depotAddressList = data
        }
    },
    mounted () {
        window.setTelePhone = (name, phone) => {
            this.setTelePhone(name, phone)
        }
        let addressList = this.pickAddress
        this.getDepotAddress()
        if (addressList && Object.keys(addressList).length) {
            this.from = {
                id: addressList.id || '',
                name: addressList.name,
                phone: addressList.phone,
                mobile: addressList.phone,
                province: addressList.province,
                city: addressList.city,
                area: addressList.area,
                address: addressList.address,
                contactName: addressList.contactName,
                contactPhone: addressList.contactPhone
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.address {
    font-size: 28px;
    color: #000000;
    height: 100%;
    overflow: hidden;
    .addressForm {
        font-size: 32px;
        .item {
            padding: 32px;
            background: #ffffff;
            position: relative;
            input {
                font-size: 32px;
            }
            .addressBook {
                position: relative;
                .addrImg {
                    position: absolute;
                    width: 48px;
                    height: 48px;
                    right: 0;
                    top: 0;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }
        }
    }
    .addressList {
        margin-top: 20px;
        padding: 30px 32px;
        background: #ffffff;
        .item {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            &:not(:last-child) {
                margin-bottom: 60px;
            }
            .item-left {
                width: 40px;
                height: 40px;
                input {
                    position: absolute;
                    margin: 0;
                }
            }
            .item-center {
                padding: 0 0 0 18px;
                .content {
                    line-height: 40px;
                }
            }
            .item-right {
                flex: 0 0 74px;
                text-align: right;
                p {
                    position: relative;
                    color: #999999;
                    height: 80px;
                    line-height: 80px;
                }
            }
        }
    }
    .msg {
        width: 182px;
        font-size: 26px;
        color: #c7c7cc;
        margin: 0 auto;
        padding-top: 160px;
        img {
            width: 176px;
            height: 176px;
            margin: 0 auto;
        }
    }
}
</style>